import './components/validator.js';
import './components/backTop.js';
import '../../sassy/component/hamburger/js/init.js';
import './components/slider.js';
import '../../sassy/component/dropdown/js/init.js';
import '../../sassy/component/select/js/init.js';
import '../../sassy/component/video/js/init.js';
import './components/modal.js';
import './components/map.js';
import './components/menu.js';
import { initCookieConsent } from '@zuii/cookie-consent';
import { Booking } from '@zuii/booking';
import '../../sassy/component/audio/js/init.js';
import '../../sassy/component/input/intlTel.ts';

function slugify(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // couper les espaces blancs en début et en fin d'ouvrage
    str = str.toLowerCase(); // convertir la chaîne en minuscules
    str = str
        .replace(/[^a-z0-9 -]/g, '') // supprimer les caractères non alphanumériques
        .replace(/\s+/g, '-') // remplacer les espaces par des traits d'union
        .replace(/-+/g, '-'); // supprimer les traits d'union consécutifs
    return str;
}

function isCurrentPage(items) {
    const pathUrl = window.location.pathname.split('/').pop();
    items.forEach(function (item) {
        const path = slugify(item.innerText.toLowerCase());
        if (path == pathUrl) {
            item.classList.add('active');
        }
    });
}

isCurrentPage(document.querySelectorAll('.menu__item'));

const currentPath = window.location.pathname.split('/').pop();
if (currentPath) {
    document.querySelector('html').classList.add(currentPath);
} else {
    document.querySelector('html').classList.add('home');
}

initCookieConsent('cookie-consent', undefined, {}, {}, ['necessary', 'analytics']);

document.querySelectorAll('.booking').forEach(async (bookingEl) => {
    // const availability = JSON.parse(bookingEl.dataset.availability || '{}');
    const fields = JSON.parse(bookingEl.dataset.fields || '[]');
    const labels = JSON.parse(bookingEl.dataset.labels || '{}');
    let itemTitle = bookingEl.dataset.itemTitle || '';
    let yearsFromNow = bookingEl.dataset.yearsFromNow ? parseInt(bookingEl.dataset.yearsFromNow, 10) : undefined;
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const lastSegment = pathSegments.length > 0 ? pathSegments[pathSegments.length - 1] : '';
    const formCode = lastSegment ? `booking-confirmation-${lastSegment}` : 'booking-confirmation-form';
    let availabilityGet = await Odrazia.get('odrazia_reservations_disponibilities', { code: formCode });
    let availability = availabilityGet ? availabilityGet.data : {};

    if (availability && availability.name) {
        const cleanName = availability.name.replace(/^balade\s+/i, '');
        itemTitle = cleanName;
        const baladeField = fields.find((f) => f.name === 'balade');
        if (baladeField) {
            baladeField.value = cleanName;
        }
    }

    if (availability && availability.nbMoisMax) {
        yearsFromNow = Math.ceil(parseInt(availability.nbMoisMax, 10) / 12);
    }

    new Booking(bookingEl, {
        disablePast: true,
        // disabledLangs: ['en'],
        yearsFromNow: yearsFromNow,
        availability: availability.availability || {},
        fields: fields.length > 0 ? fields : undefined,
        labels: labels,
        itemTitle: itemTitle,
        onSlotSelect: (date, slot, formData) => {
            if (typeof Odrazia !== 'undefined') {
                Odrazia.post('odrazia_form_index', { formCode }, formData, true);
            } else {
                console.log('Réservation confirmée (Odrazia non défini) :', date, slot, formData);
            }
        },
    });
});
